module.exports = __webpack_public_path__ + "img/Bergungsräumgerät.a8933970.svg";